import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BottomSheet, Button, DateField, SelectField } from '@sauda/ui/kit';
import { istDateInput } from '../../lib/money-input.js';

/** Every half hour from 7 am to 9 pm: the times a visit is fixed for. */
export const VISIT_TIMES = Array.from({ length: 29 }, (_, i) => {
  const minutes = 7 * 60 + i * 30;
  const hour = Math.floor(minutes / 60);
  const minute = minutes % 60;
  const value = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
  const shown = `${hour % 12 === 0 ? 12 : hour % 12}:${String(minute).padStart(2, '0')} ${hour < 12 ? 'am' : 'pm'}`;
  return { value, label: shown };
});

/** The instant for a date and a time in India, which the API turns into the visit's slot and reminders. */
export function visitInstant(date: string, time: string): string {
  return `${date}T${time}:00+05:30`;
}

/**
 * Fix or move a visit: a date and a time. The client is told on WhatsApp and gets reminders the
 * evening before and two hours before.
 */
export function VisitTimeSheet({
  open,
  onClose,
  title,
  actionLabel,
  pending,
  onSubmit,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  actionLabel: string;
  pending: boolean;
  onSubmit: (at: string) => void;
}) {
  const { t } = useTranslation();
  const [date, setDate] = useState(istDateInput());
  const [time, setTime] = useState('10:00');
  useEffect(() => {
    if (open) {
      setDate(istDateInput());
      setTime('10:00');
    }
  }, [open]);
  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      label={title}
      title={title}
      closeLabel={t('app.close')}
      actions={
        <Button
          size="lg"
          block
          disabled={date === '' || time === ''}
          loading={pending}
          onClick={() => onSubmit(visitInstant(date, time))}
        >
          {actionLabel}
        </Button>
      }
    >
      <DateField label={t('visits.date')} value={date} onChange={setDate} min={istDateInput()} />
      <SelectField
        label={t('visits.time')}
        value={time}
        onChange={(e) => setTime(e.target.value)}
        options={VISIT_TIMES}
      />
      <p className="k-t-body-sm k-muted">{t('visits.timeHelp')}</p>
    </BottomSheet>
  );
}
